/**
 * Generated by `tools/geo/fetch/build-vilnius-modular-city-assets.mjs`.
 *
 * Official kiosk footprints remain in geography and collision while their
 * generic render is replaced. Documented freestanding kiosks receive only an
 * explicit lightweight body collider. Do not edit this file by hand; rebuild
 * the modular city source manifest.
 */
export const VILNIUS_MODULAR_CITY_REPLACED_BUILDING_ID_VALUES = Object.freeze([
  "grpk:2fdd9222-95c7-40a3-a45d-8da5c7151381",
  "grpk:378687dc-2afa-424c-a3d8-f20c55b24f9e",
  "grpk:677a1e82-75d6-46b6-9fd3-2525a3b6e9b3",
  "grpk:9F81C701-C962-4BC9-A878-6F7524B7C605",
  "grpk:9b2842d7-62f0-403d-9d76-875bfd61467e",
  "grpk:C5BD29F4-D4D0-40F1-A80C-B60055192841",
]);

export const VILNIUS_MODULAR_CITY_STANDALONE_COLLISION_VALUES = Object.freeze([
  {
    "id": "narvesen-kiosk-node-1432031219",
    "tileId": "1:7",
    "origin": {
      "x": 425.361,
      "y": 62.398,
      "z": 1912.304
    },
    "rotationYRadians": 0.1574,
    "bodySizeM": {
      "x": 3.7,
      "y": 2.72,
      "z": 2.4
    }
  }
] as const);
